const DAYS = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
const DAY_LABELS = {
  mon: 'Mon',
  tue: 'Tue',
  wed: 'Wed',
  thu: 'Thu',
  fri: 'Fri',
  sat: 'Sat',
  sun: 'Sun',
};

const slotStart = entry => entry?.startTime || entry?.start || null;
const slotEnd = entry => {
  const end = entry?.endTime || entry?.end || null;
  return end === '00:00' ? '24:00' : end;
};

/**
 * Format an HH:mm plan time as 12-hour clock (1:00 AM).
 *
 * @param {string} hhmm
 * @returns {string}
 */
export const formatHour12 = hhmm => {
  if (!hhmm || typeof hhmm !== 'string') {
    return '';
  }
  const [hourPart, minutePart = '00'] = hhmm.split(':');
  let hour = Number.parseInt(hourPart, 10);
  if (!Number.isFinite(hour)) {
    return hhmm;
  }
  if (hour === 24) {
    hour = 0;
  }
  const suffix = hour >= 12 ? 'PM' : 'AM';
  const hour12 = hour % 12 === 0 ? 12 : hour % 12;
  const minutes = minutePart.padStart(2, '0');
  return `${hour12}:${minutes} ${suffix}`;
};

/**
 * Compact weekly hours from an availability plan.
 *
 * @param {Object} [plan]
 * @returns {Array<{ day: string, label: string, slots: Array<string> }>}
 */
export const weeklyAvailabilityRows = (plan = {}) => {
  const entries = Array.isArray(plan.entries) ? plan.entries : [];
  return DAYS.map(day => {
    const slots = entries
      .filter(entry => entry?.dayOfWeek === day && (entry.seats == null || entry.seats > 0))
      .map(entry => {
        const start = slotStart(entry);
        const end = slotEnd(entry);
        return start && end ? `${formatHour12(start)}–${formatHour12(end)}` : null;
      })
      .filter(Boolean);
    return { day, label: DAY_LABELS[day], slots };
  });
};

/**
 * @param {Object} [plan]
 * @returns {boolean}
 */
export const hasWeeklyAvailability = (plan = {}) =>
  weeklyAvailabilityRows(plan).some(row => row.slots.length > 0);
